import { render } from "./Home.vue?vue&type=template&id=61fdd5c4"
const script = {}

import "./Home.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script